// extracted by mini-css-extract-plugin
module.exports = {"talk":"Talk-module--talk--3V4My","listen":"Talk-module--listen--3D2zV"};